var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t("influencer_panel.material_title"),
        "ok-only": true,
        "ok-title": _vm.$t("action.close"),
        "ok-variant": "outline-secondary",
        size: "lg",
      },
      on: { hidden: _vm.reset },
    },
    [
      _c(
        "b-skeleton-wrapper",
        {
          attrs: { loading: _vm.loading },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function () {
                return [
                  _c("b-skeleton", { attrs: { width: "60%" } }),
                  _c("b-skeleton", { attrs: { width: "90%" } }),
                  _c("b-skeleton", { attrs: { width: "80%" } }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.error
            ? _c("section-error", {
                attrs: { message: _vm.error },
                on: { retry: _vm.load },
              })
            : _vm.material
            ? [
                _c("p", { staticClass: "material__campaign" }, [
                  _vm._v(_vm._s(_vm.campaignName(_vm.current))),
                ]),
                _vm.material.briefing
                  ? _c("div", { staticClass: "material__block" }, [
                      _c("div", { staticClass: "material__label" }, [
                        _vm._v(_vm._s(_vm.$t("influencer_panel.briefing"))),
                      ]),
                      _c("p", { staticClass: "material__text" }, [
                        _vm._v(_vm._s(_vm.material.briefing)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.material.rules
                  ? _c("div", { staticClass: "material__block" }, [
                      _c("div", { staticClass: "material__label" }, [
                        _vm._v(_vm._s(_vm.$t("influencer_panel.rules"))),
                      ]),
                      _c("p", { staticClass: "material__text" }, [
                        _vm._v(_vm._s(_vm.material.rules)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.hashtags.length
                  ? _c("div", { staticClass: "material__block" }, [
                      _c("div", { staticClass: "material__label" }, [
                        _vm._v(_vm._s(_vm.$t("influencer_panel.hashtags"))),
                      ]),
                      _c(
                        "div",
                        { staticClass: "material__chips" },
                        _vm._l(_vm.hashtags, function (tag) {
                          return _c(
                            "b-badge",
                            { key: tag, attrs: { variant: "light-primary" } },
                            [_vm._v("#" + _vm._s(tag))]
                          )
                        }),
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.material.disclosure_tag
                  ? _c(
                      "div",
                      { staticClass: "material__block" },
                      [
                        _c("div", { staticClass: "material__label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("influencer_panel.disclosure_tag"))
                          ),
                        ]),
                        _c("b-badge", { attrs: { variant: "light-warning" } }, [
                          _vm._v(_vm._s(_vm.material.disclosure_tag)),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.assets.length
                  ? _c("div", { staticClass: "material__block" }, [
                      _c("div", { staticClass: "material__label" }, [
                        _vm._v(_vm._s(_vm.$t("influencer_panel.material"))),
                      ]),
                      _c(
                        "div",
                        { staticClass: "material__assets" },
                        _vm._l(_vm.assets, function (asset) {
                          return _c(
                            "a",
                            {
                              key: asset.id,
                              staticClass: "material__asset",
                              attrs: {
                                href: asset.url,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "ImageIcon", size: "15" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    asset.name ||
                                      asset.file_name ||
                                      "#" + asset.id
                                  )
                                ),
                              ]),
                              _c("feather-icon", {
                                attrs: { icon: "ExternalLinkIcon", size: "13" },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm.isEmpty
                  ? _c("hb-empty-state", {
                      attrs: {
                        title: _vm.$t("influencer_panel.no_material"),
                        icon: "ImageIcon",
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }